import { classicList } from "@/mocks/anime";

export default function Classics() {
  return (
    <section id="classics" className="bg-foreground-950 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-4 md:mb-12 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-vip-crown-line"></i>
              经典动画回顾
            </span>
            <h2 className="mt-3 font-heading text-3xl text-background-50 md:text-4xl">
              值得反复重温的经典之作
            </h2>
            <p className="mt-2 max-w-xl text-sm text-background-200/80">
              回顾过去数年广受好评的作品，老观众重温青春，新观众快速补番。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {classicList.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-2xl bg-background-50 transition-all hover:-translate-y-1"
            >
              <div className="relative h-64 w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title}经典动画回顾`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-semibold text-background-50">
                  {item.tag}
                </span>
                <div className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-black/55 px-2.5 py-1 text-xs font-semibold text-amber-300 backdrop-blur-sm">
                  <i className="ri-star-fill"></i>
                  {item.score}
                </div>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg text-foreground-950">{item.title}</h3>
                  <span className="text-xs text-foreground-500">{item.year}</span>
                </div>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {item.desc}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3">
                  <span className="text-xs text-foreground-500">{item.episodes}</span>
                  <a
                    href="#recommend"
                    className="inline-flex items-center gap-1 text-xs font-semibold text-primary-700 hover:text-primary-600"
                  >
                    了解更多 <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}